import { ModuleData } from "../handlers";

let elImageWindow: Window | null = null;

export const openOrUpdateImageWindow = (
  imageSrc: string,
  moduleData: ModuleData
) => {
  const {
    serialNumber: serial,
    inspectionTime,
    maxVoltage: voltage,
    maxCurrent: current,
    elResult: moduleJudgement,
  } = moduleData;
  const windowFeatures = "width=1200,height=700,left=100,top=100";

  if (!elImageWindow || elImageWindow.closed) {
    elImageWindow = window.open("", "ElImageWindow", windowFeatures);

    if (!elImageWindow) {
      alert("Popup blocked!");
      return;
    }

    elImageWindow.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <title>EL Image Viewer</title>
        <style>
          body {
            margin: 0;
            background: #111;
            color: white;
            font-family: Arial, sans-serif;
            display: flex;
            flex-direction: row;
            height: 100vh;
            overflow: hidden;
          }
          .image-container {
            flex: 2;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: black;
          }
          .image-container img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            cursor: zoom-in;
            box-shadow: 0 0 20px white;
          }
          .info-container {
            flex: 1;
            background-color: #222;
            padding: 20px;
            box-sizing: border-box;
          }
          .info-container h2 {
            margin-top: 0;
          }
          .info-table {
            width: 100%;
            border-collapse: collapse;
          }
          .info-table td {
            padding: 4px 8px;
            border-bottom: 1px solid #444;
          }
          .info-table td:first-child {
            font-weight: bold;
            color: #ccc;
          }
        </style>
      </head>
      <body>
        <div class="image-container">
          <img id="el-image" src="" />
        </div>
        <div class="info-container">
          <h2>Measurement Results</h2>
          <table class="info-table">
            <tbody id="info-table-body">
              <!-- Filled dynamically -->
            </tbody>
          </table>
        </div>
        <script>
          window.addEventListener('message', (event) => {
            if (event.data?.type === 'update-image') {
              document.getElementById('el-image').src = event.data.src;
              const info = [
                ['Serial Number', event.data.serial],
                ['Inspection Time', event.data.inspectionTime],
                ['Voltage', event.data.voltage.toFixed(2) + ' V'],
                ['Current', event.data.current.toFixed(2) + ' A'],
                ['Judgement', event.data.moduleJudgement]
              ];
              const tbody = document.getElementById('info-table-body');
              tbody.innerHTML = '';
              info.forEach(([label, value]) => {
                const row = document.createElement('tr');
                row.innerHTML = '<td>' + label + '</td><td>' + value + '</td>';
                tbody.appendChild(row);
              });
            }
          });
        </script>
      </body>
      </html>
    `);

    elImageWindow.document.close();
  }

  // Envia os dados
  elImageWindow.postMessage(
    {
      type: "update-image",
      src: imageSrc,
      serial,
      inspectionTime,
      voltage,
      current,
      moduleJudgement,
    },
    "*"
  );
};
